const externalLink = () => {
	const galleries = document.querySelectorAll('.gallery-links' || null);
	if (galleries) {
		galleries.forEach((gallery) => {
			const items = gallery.querySelectorAll(
				'.gallery-links__list__item'
			);
			items.forEach((item) => {
				const link = item.querySelector('a');
				const isExternal = link.getAttribute('target') === '_blank';
				if (isExternal) {
					link.insertAdjacentHTML(
						'beforeend',
						`<i class="external-link"></i>`
					);
				}
			});
		});
	}
};

window.addEventListener('load', () => {
	externalLink();
});
